import { gql } from '@apollo/client';

const USER_FIELDS_WITH_CLIENTS = gql`
  fragment UserFieldsWithClients on User {
    id
    email
    name
    clientUsers {
      id
      admin
      client { id, name }
    }
  }
`;

export const USERS = gql`
  ${USER_FIELDS_WITH_CLIENTS}
  query Users {
    users {
      ...UserFieldsWithClients
    }
  }
`;

export const INVITE_USER = gql`
  mutation InviteUser ($input: InviteUserInput!) {
    inviteUser (input: $input) {
      user { id }
      errors { path, message }
    }
  }
`;

export const UPDATE_USER = gql`
  mutation UpdateUser ($input: UpdateUserInput!) {
    updateUser (input: $input) {
      user { id }
      errors { path, message }
    }
  }
`;
